import { Badge, Box, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { FiFileText } from "react-icons/fi";

export function FileToExportRow({
  name,
  fileType,
  note,
}: {
  name: string;
  fileType?: string;
  note?: string;
}): React.ReactElement {
  return (
    <HStack spacing={2} align="center">
      <Box
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        p={2.5}
        borderRadius="md"
        bg="blue.50"
        color="blue.400"
        borderColor="blue.200"
        flexShrink={0}
        borderWidth="1px"
      >
        <Icon as={FiFileText} boxSize={4} />
      </Box>

      <VStack align="stretch" justify="center" spacing={0} minW={0}>
        <HStack spacing={2} align="center">
          <Text fontSize="md" fontWeight="semibold">
            {name}
          </Text>

          {fileType && (
            <Badge
              colorScheme="gray"
              variant="subtle"
              fontSize="0.65rem"
              flexShrink={0}
            >
              {fileType}
            </Badge>
          )}
        </HStack>

        {note && <Text fontSize="sm">{note}</Text>}
      </VStack>
    </HStack>
  );
}
